<div
  data-cy="past-inventories-section"
  class="past-inventories"
  [ngClass]="
    platform === PlatformEnum.mobile
      ? 'mobile'
      : platform === PlatformEnum.tablet
      ? 'tablet'
      : 'desktop'
  "
>
  <ion-grid class="inventory-header-search">
    <ion-row>
      <ion-col [size]="platform !== PlatformEnum.desktop ? 9.25 : 10">
        <ion-label
          data-cy="past-inventories-select-inventory-header"
          class="bold-font-weight inventory-header-text"
        >
          {{ 'i18n.inventory.selectAnInventory' | translate }}
        </ion-label>
      </ion-col>
      <ion-col [size]="platform !== PlatformEnum.desktop ? 2.75 : 2">
        <ion-label
          data-cy="past-inventories-products-header"
          class="regular-font-weight inventory-subheader-text"
        >
          {{ 'i18n.inventory.products' | translate }}
        </ion-label>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-searchbar
        data-cy="inventory-past-searchbar"
        class="search"
        mode="md"
        placeholder="{{ 'i18n.inventory.searchForInventory' | translate }}"
        [(ngModel)]="searchKey"
        (ionClear)="resetSearch()"
        (ionInput)="search()"
      >
      </ion-searchbar>
    </ion-row>
  </ion-grid>

  <!-- INVENTORIES -->
  <div
    data-cy="past-inventories-container"
    class="inventory-selectable-items-container"
  >
    <ng-container *ngIf="inventories?.length > 0; else noResultsFound">
      <div
        *ngFor="let inventory of inventories; let i = index"
        [attr.data-cy]="'past-inventories-section-' + i"
        class="inventory-selectable-item"
        [class.is-selected]="inventory?.isSelected"
        (click)="onSelectInventory(inventory)"
      >
        <div
          [attr.data-cy]="'past-inventories-checkbox-section-' + i"
          class="inventory-checkbox-section"
        >
          <ion-checkbox
            [attr.data-cy]="'past-inventories-section-checkbox-' + i"
            mode="ios"
            [checked]="inventory.isSelected"
            (ionInput)="onSelectInventory(inventory)"
          ></ion-checkbox>
        </div>
        <ion-item
          [attr.data-cy]="'past-inventories-info-section-' + i"
          [class.inventory-completed]="
            inventory?.status === InventoryStatus.COMPLETED
          "
          lines="none"
        >
          <div
            *ngIf="inventory?.status === InventoryStatus.COMPLETED"
            [attr.data-cy]="'past-inventories-completed-banner-' + i"
            class="inventory-completed-banner"
          >
            <p
              [attr.data-cy]="'past-inventories-completed-banner-text-' + i"
              class="bold-font-weight"
            >
              {{ 'i18n.inventory.complete' | translate }}
            </p>
          </div>
          <ion-label
            [attr.data-cy]="'past-inventories-name-date-text-' + i"
            class="bold-font-weight inventory-header-text ion-text-wrap"
          >
            {{ inventory?.inventoryName }}
            {{ inventory?.inventoryDate | date: 'M/d/yyyy' }}
            <p
              [attr.data-cy]="'past-inventories-last-updated-text-' + i"
              class="regular-font-weight inventory-subheader-text"
            >
              {{ 'i18n.inventory.lastUpdated' | translate }}&nbsp;{{
                inventory?.ecomUpdateDtm | date: 'MM/dd/yyyy'
              }}
            </p>
          </ion-label>
          <ion-badge
            [attr.data-cy]="'past-inventories-num-products-icon-' + i"
            class="bold-font-weight inventory-badge"
            mode="ios"
            slot="end"
          >
            {{ inventory?.numProducts ?? 0 }}
          </ion-badge>
        </ion-item>
      </div>
    </ng-container>
    <ng-template #noResultsFound>
      <div class="inventory-no-results-found">
        {{ 'i18n.inventory.noResultsFound' | translate }}
      </div>
    </ng-template>
  </div>
</div>
